export * from './loyalty-hero-header.shared.module';
